import { FunctionalComponent, h } from '@stencil/core';
import { AppMedia, AppLink, AppLightbox, AppRTE } from './'

interface AppListItem {
    Title?: string;
    SubTitle?: string;
    Description?: string;
    Link?: any;
    Media?: any
    Lightbox?: boolean;
    Eager?: boolean;
}

export const AppListItem: FunctionalComponent<AppListItem> = ({ Title, SubTitle, Description, Link, Media, Lightbox = false }) => {

    return (
        <div class="uk-margin uk-background-muted uk-position-relative uk-overflow-hidden">
            <div class="uk-grid-small" uk-grid>
                <div class="uk-width-1-1 uk-width-1-3@s">
                    <div class="uk-cover-container uk-height-1-1" style={{ 'min-height': '210px' }}>
                        <AppMedia size="(max-width: 638px) 80vw, (max-width: 958px) 30vw, 20vw" eager media={Media} cover />
                    </div>
                </div>
                <div class="uk-width-1-1 uk-width-2-3@s uk-position-relative uk-overflow-hidden">
                    <div class="uk-padding uk-padding-remove-top uk-padding-top@s uk-margin-top  uk-position-relative">
                        {SubTitle && <div class="uk-heading-small wsio-gold uk-margin-remove">{SubTitle}</div>}
                        <h3 class="uk-heading-medium wsio-darker-green uk-text-uppercase uk-margin-small-top">{Title}</h3>
                        <AppRTE className="wsio-dark-grey" markdown={Description} />
                        {Link && (
                            Lightbox ? <div uk-lightbox="video-autoplay=1;"><AppLightbox className="uk-button uk-button-primary" data={Link} /></div> :
                                <AppLink className="uk-button uk-button-primary" data={Link} />
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
};